import { render, staticRenderFns } from "./ReviewFormBuilder.vue?vue&type=template&id=68ffa07c&"
import script from "./ReviewFormBuilder.vue?vue&type=script&lang=js&"
export * from "./ReviewFormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ReviewFormBuilder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports